export default __webpack_public_path__ + "static/media/BTSTU KIK2.383a0ca7.wav";